import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { AuthGuard } from '../auth/auth.guard';

@Component({
  selector: 'vr-quickpanel',
  templateUrl: './quickpanel.component.html',
  styleUrls: ['./quickpanel.component.scss']
})
export class QuickpanelComponent implements OnInit {

  todayDay: string;
  todayDate: string;
  todayDateSuffix: string;
  todayMonth: string;
  enterprises;
  user;

  constructor(
    public authGuard: AuthGuard,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.todayDay = moment().format('dddd');
    this.todayDate = moment().format('Do');
    this.todayDate = this.todayDate.replace(/\D/g, '');
    this.todayDateSuffix = moment().format('Do');
    this.todayDateSuffix = this.todayDateSuffix.replace(/[0-9]/g, '');
    this.todayMonth = moment().format('MMMM');
    this.enterprises = this.authGuard.enterprises;
    this.user = this.authGuard.session;
  }

  changeDefaultEnterprise(id) {
    this.http.post(environment.API_PATH + 'auth/enterprise', {enterprise_id: id}, {withCredentials: true}).subscribe(response => {});
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/quickpanel/quickpanel.component.ts